/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Empty_Library_TitleInputs */



/**
* | output |
* | --- |
* | "No practice conversations yet" |
*
* @param {Practice_Empty_Library_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_empty_library_title = /** @type {((inputs?: Practice_Empty_Library_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Empty_Library_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Nog geen oefengesprekken")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pas encore d'entretiens d'entraînement")
	return /** @type {LocalizedString} */ ("No practice conversations yet")
});